import { NotificationDataSource } from './notification-data-source';
import { IContext } from '../types';

export const getNotificationDataSource = async (context: IContext, getNotifications: Function) => {
  const notificationDataSource = new NotificationDataSource(context, getNotifications);

  return notificationDataSource;
};
